import { API_ROUTE_ADMIN_REPORTS_SETUP_EXPORT } from '@/resources/api-routes'
import { post } from '@/util/auth'

import type { ReportSetupExportSettingsTypeOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const postSetupExportSettings = (payload: ReportSetupExportSettingsTypeOriginal) =>
  post<null>(API_ROUTE_ADMIN_REPORTS_SETUP_EXPORT, payload, IS_NEW_BACKEND_API)
